import {Component} from '@angular/core';

@Component({
  selector: 'mz-radio-button-container',
  templateUrl: './radio-button-container.component.html',
  styleUrls: ['./radio-button-container.component.scss'],
})
export class MzRadioButtonContainerComponent {
}
